<span
	tuiAvatar="@tui.flask-conical"
	class="chemical-thumbnail__avatar"
	[round]="false"
	size="m"
></span>
